import React from 'react';
import Heading from '@legacy-vfuk/core-heading';
import RichTextElement from '../pageBuilder/Elements/RichText';
import { VideoSummaryProps } from './types/VideoSummary.types';
import {
  bgWhite,
  bgAbbey,
  articleSummary,
  textBlock,
} from './styles/Article.styles';
import {
  VideoContainerWrapper,
  videoiframe,
} from './styles/VideoSummary.styles';

const VideoSummary = ({
  data,
  backgroundColor = 'white',
}: VideoSummaryProps) => {
  const { name, videoSummary, slug } = data;
  const linkCSS = backgroundColor === 'white' ? bgWhite : bgAbbey;

  // TODO: Sort out that nasty a-link - done in a hurry to delete an unwanted link to yt.

  return (
    <div css={articleSummary}>
      <a
        css={linkCSS}
        className="card_resize card"
        data-testid={`videoSummary-${slug}`}
      >
        <VideoContainerWrapper
          data-testid="videoContainer"
        >
          <iframe
            css={videoiframe}
            id="ytplayer"
            src={`https://www.youtube.com/embed/${slug}`}
            type="text/html"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          />
        </VideoContainerWrapper>
        <div css={textBlock}>
          <Heading text={name} level={4} noMargin={true} />
          <RichTextElement rawRichText={videoSummary.raw} />
        </div>
      </a>
    </div>
  );
};

export default VideoSummary;
